import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=7e48493e&scoped=true"
import script from "./AppMain.vue?vue&type=script&lang=js"
export * from "./AppMain.vue?vue&type=script&lang=js"
import style0 from "./AppMain.vue?vue&type=style&index=0&id=7e48493e&scoped=true&lang=css"
import style1 from "./AppMain.vue?vue&type=style&index=1&id=7e48493e&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e48493e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e48493e')) {
      api.createRecord('7e48493e', component.options)
    } else {
      api.reload('7e48493e', component.options)
    }
    module.hot.accept("./AppMain.vue?vue&type=template&id=7e48493e&scoped=true", function () {
      api.rerender('7e48493e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/ezpay/AppMain.vue"
export default component.exports